import { Modal, type ModalProps, VerificationDocumentsTable, VerificationDocumentUploadForm } from '@app/components'
import { useSugarContext } from '@app/providers'
import { type SugarEnrollmentItem } from '@app/types'
import { Divider, Stack, Text } from '@mantine/core'
import { type FC } from 'react'

export interface VerificationDocumentsModalProps extends Omit<ModalProps, 'children' | 'opened' | 'onClose' | 'title'> {
  enrollmentItem: SugarEnrollmentItem | null
  onClose: () => void
}

export const VerificationDocumentsModal: FC<VerificationDocumentsModalProps> = ({
  enrollmentItem,
  onClose,
  ...props
}) => {
  const { rosterProgramYearId, siteId } = useSugarContext()
  const enrollmentId = enrollmentItem?.enrollment.id ?? null
  const programYearId = rosterProgramYearId ?? null
  const ready = !!(enrollmentId && programYearId && siteId)

  return (
    <Modal
      closeOnClickOutside={false}
      fullScreen
      onClose={onClose}
      opened={!!enrollmentItem}
      size='lg'
      title={`Documents: ${enrollmentItem?.contact.name ?? ''}`}
      {...props}
    >
      <Stack spacing='lg'>
        {ready ? (
          <>
            <VerificationDocumentUploadForm
              enrollmentId={enrollmentId}
              programYearId={programYearId}
            />
            <Divider />
            <VerificationDocumentsTable
              enrollmentId={enrollmentId}
              programYearId={programYearId}
            />
          </>
        ) : (
          <Text
            color='dimmed'
            size='sm'
          >
            Select a program year to view documents.
          </Text>
        )}
      </Stack>
    </Modal>
  )
}
